/// <amd-module name="Mention/Common/Util" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

const CODE_BLOCK_REGEX = "(```[a-z]*[\\s\\S]*?```)|(<pre>[a-z]*[\\s\\S]*?</pre>)|(`[a-z]*[\\s\\S]*?`)";
const EMPTY_LINES_IN_BLOCK_REGEX = "\\n[\\s]*\\n";

const CONTAINER_REGEX = "(:::[\\s]*\\S+[\\s\\r\\n]+[\\s\\S]*?:::)";

export interface ArtifactIndexResult {
    start: number;
    end: number;
}

/**
 * Gets all the code block in the text.
 * @param {string} text string to parse for the code blocks.
 * @returns list of indices (start and end index) of the code blocks with the text input.
 * Code blocks starts with (``` code ```) or (<pre> code </pre>) or (` code `)
 */
export function parseCodeBlocksFromText(text: string): ArtifactIndexResult[] {
    var codeBlockIndices: ArtifactIndexResult[] = [];
    var pattern = new RegExp(CODE_BLOCK_REGEX, "ig");
    const emptyLinePattern = new RegExp(EMPTY_LINES_IN_BLOCK_REGEX, "ig");
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(text))) {
        let shouldInclude = true;
        // if the code block is inline one like (`code`),
        // then there shouldn't be any empty new lines inside that block, for it to be valid code snippet.
        if (text[match.index] === "`" && text[match.index + 1] !== "`") {
            const snip = text.substring(match.index, pattern.lastIndex);
            shouldInclude = !emptyLinePattern.exec(snip); // push this snippet only if there's no empty new line inside it.
        }

        if (shouldInclude) {
            codeBlockIndices.push({
                start: match.index,
                end: pattern.lastIndex
            });
        }
    }
    return codeBlockIndices;
}

/**
 * Gets all the container section in the text
 * @param {string} text string to parse the container sections
 */
export function parseContainersFromText(text: string): ArtifactIndexResult[] {
    const containerIndices: ArtifactIndexResult[] = [];
    const pattern = new RegExp(CONTAINER_REGEX, "ig");
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(text))) {
        containerIndices.push({
            start: match.index,
            end: pattern.lastIndex
        });
    }

    return containerIndices;
}

export function getIgnoreMatch(ignoreBlocks: ArtifactIndexResult[]): ((matchIndex: number) => boolean) | undefined {
    if (ignoreBlocks.length) {
        return (matchIndex: number) => {
            return ignoreBlocks.some(ignoreBlock => matchIndex >= ignoreBlock.start && matchIndex <= ignoreBlock.end);
        };
    }
}

export function useStorageKeysInMentions(pageContext: IVssPageContext): boolean {
    return isFeatureFlagEnabled(pageContext, "VisualStudio.Mentions.UseStorageKeyInMentions");
}
